import React from "react";
import DOMPurify from "dompurify";

const ClosedCaption = ({ ccList, isSideNavOpen }) => {
  if (!ccList || ccList.length === 0) {
    return null;
  }

  return (
    <div className={`cc-container ${isSideNavOpen ? "shrink" : ""}`}>
      {ccList.map((ccObj, index) => (
        <p
          key={index}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(ccObj.text, {
              USE_PROFILES: { html: true },
            }),
          }}
        />
      ))}
    </div>
  );
};

export default ClosedCaption;
